import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    Grid,
    Stack,
    Divider
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';

import get from "lodash/get";
import InputText from "../../../components/form/InputText";
import InputTextDetail from "../../../components/form/InputTextDetail";
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import Alert2 from "../../../components/form/Alert";
import { useCanView } from "../../../config/hook/UserPermissions";

import Validator from "./validatorPaymentEdit";

import FormatMoney from "../../../components/form/FormatMoney"

const Alert = ({
    __,
    open,
    close,
    selected,
    update
}) => {
    const current = selected
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
    const canView = useCanView();
    const { id: routeId } = useParams();

    const onCloseModal = (r) => {
        close();
    }

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const onSubmit = (values) => {
        if (canView("TRANSACCIONES/RUTAS/COBROS", "update")) {
            const body = {
                idRouteBilling: Number(get(current, "id")),
                idRoute: Number(routeId),
                quantity: Number(get(current, "quantity")),
                id: Number(get(current, "id")),
                customerId: String(get(current, "customerId")),
                price: Number(get(values, "price")),
                comments: String(get(values, "comments")),
            }
            update(body);
            close();
        } else {
            setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para actualizar el cobro de la ruta.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }


    const initialValues = {

        cod_Invoice: get(current, "cod_Invoice", ""),
        price: get(current, "price", ""),
        descriptionCodeInvoice: get(current, "descriptionCodeInvoice", ""),
        quantity: get(current, "quantity", ""),
        id: get(current, "id", ""),
        comments: get(current, "comments", "")
    }

    return (
        <div>
            <Dialog onClose={close} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {__("labels.19")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <div>
                {!open
                        ? (
                            <Box sx={{ minHeight: 200, width: "100%" }} />
                        ) : (
                            <Formik initialValues={initialValues}
                               validationSchema={Validator(__)}
                                onSubmit={onSubmit}>
                                {formik => (
                                    <form id="route-cost-edit-form" onSubmit={get(formik, "handleSubmit")}>
                                        <div className='relative'>
                                            <Divider />
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputTextDetail
                                                            formik={formik}
                                                            name="cod_Invoice"
                                                            label={__(`formPaymentEdit.cod_Invoice.label`)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputTextDetail
                                                            formik={formik}
                                                            name="descriptionCodeInvoice"
                                                            label={__(`formPaymentEdit.descriptionCodeInvoice.label`)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputTextDetail
                                                            formik={formik}
                                                            name="quantity"
                                                            label={__(`formPaymentEdit.quantity.label`)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="price"
                                                            label={__(`formPaymentEdit.price.label`)}
                                                            InputProps={{
                                                                inputComponent: FormatMoney,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={6}>
                                                        <InputText
                                                            formik={formik}
                                                            name="comments"
                                                            label={__(`form.comments.label`)}
                                                            placeholder={__(`form.comments.placeholder`)}
                                                            multiline
                                                            rows={3}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        )}
                </div>
                <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                    <LoadingButton variant="contained" startIcon={<SaveIcon/>} color="secondary" type="submit" form="route-cost-edit-form">{__("action.save")}</LoadingButton>
                    <Button variant='outlined' color="secondary" onClick={onCloseModal} >{__(`action.cancel`)}</Button>
                </Stack>
                <Alert2
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
            </Dialog>
        </div >
    );
}

export default Alert